import { render, staticRenderFns } from "./DeleteJobDialog.vue?vue&type=template&id=60369188&"
import script from "./DeleteJobDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteJobDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports